import { render, staticRenderFns } from "./MoreAction.vue?vue&type=template&id=3876284f"
import script from "./MoreAction.vue?vue&type=script&lang=js"
export * from "./MoreAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports